import { useMemo } from "react";
import { SectionPage } from "@/components/section-page";
import { DataTable } from "@/composites/data-table/index";
import { HardwareItemType } from "@/schemas/hardware";
import { useTableInstalledStyles } from "./table-installed.styles";
import { LocalizationText } from "@/app/index";
import { ProductImage } from "@/components/product-image/index";
import { Link } from "@/components/link";
import { Text, Flex, Button } from "@/base/components/index";
import { usePageContextHardware } from "../../context/hardware-context";

export const TableInstalled = () => {
  const { styles } = useTableInstalledStyles();
  const {
    controllerDataTableInstalled,
    controllerHardwareInstall,
    currentLang,
  } = usePageContextHardware();

  const handleClickChange = (record: HardwareItemType) => {
    controllerHardwareInstall.open(record);
  };

  const columns: any = useMemo(
    () => [
      {
        dataIndex: "ProductName",
        title: (
          <LocalizationText value="hardware.table.installed.column.hardware" />
        ),
        minWidth: 200,
        render: (value: string, record: HardwareItemType) => (
          <Flex align="center" gap={12}>
            <ProductImage
              src={record.Product?.ImageThumbName}
              width={40}
              height={40}
            />
            <Text>{value}</Text>
          </Flex>
        ),
      },
      {
        dataIndex: "BusinessUnitName",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.installed.column.business.unit" />
        ),
        render: (text: string, record: HardwareItemType) =>
          record.BusinessUnitId && text ? (
            <Link
              to={`/${currentLang}/business-units/${record.BusinessUnitId}`}
              type="primary"
              strong
            >
              {text}
            </Link>
          ) : (
            text
          ),
      },
      {
        dataIndex: "LicenseKey",
        minWidth: 160,
        title: <LocalizationText value="hardware.table.installed.column.key" />,
      },
      {
        dataIndex: "ProductStatusName",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.installed.column.status" />
        ),
      },
      {
        dataIndex: "Actions",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.installed.column.actions" />
        ),
        render: (_: string, record: HardwareItemType) => (
          <Button
            variant="text"
            color="primary"
            onClick={() => handleClickChange(record)}
          >
            <LocalizationText value="hardware.table.installed.column.actions.change" />
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <DataTable
        controller={controllerDataTableInstalled}
        columns={columns}
        searched={false}
      />
    </SectionPage>
  );
};
